import { Component, AfterViewInit } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { VersionService } from './services/version.service';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
  `,
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'gasPremiaCrm';

  // Desde la raíz (y no desde el header) para cubrir también login y vistas públicas
  constructor(private versionService: VersionService) {
    this.versionService.watchServiceWorkerUpdates();
  }
}
